import { Alert } from '@ethings/ui-toolkit';
import { FallbackRender, ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { FC, PropsWithChildren, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorBoundaryProps extends PropsWithChildren {
  fallback?: ReactElement | FallbackRender;
}

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({ children, fallback }) => {
  const { t } = useTranslation(['common']);

  return (
    <SentryErrorBoundary
      fallback={fallback ?? (
        <Alert severity='error'>
          {t('common:page.errors.system-error.title')}
        </Alert>
      )}>
      {children}
    </SentryErrorBoundary>
  );
};
